var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.lang)?_c('img',{staticStyle:{"border-radius":"6px","overflow":"hidden"},attrs:{"src":'/img/kontakt_' + _vm.lang + '.jpg'}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }